import { CalendarPlus } from "@phosphor-icons/react";
import { useSettings } from "@/contexts/SettingsContext";

export const CalendlyButton = ({ className = "btn-outline gap-2", label, testId = "book-a-call-button" }) => {
  const settings = useSettings();
  const calendlyUrl = settings.calendly_url;

  if (settings.book_call_enabled === false) return null;

  const openCalendly = () => {
    if (!calendlyUrl) return;
    if (window.Calendly) {
      window.Calendly.initPopupWidget({ url: calendlyUrl });
    } else {
      window.open(calendlyUrl, "_blank");
    }
  };

  return (
    <button type="button" onClick={openCalendly} data-testid={testId} className={className}>
      {label || settings.book_call_label || "Book a Call"}
      <CalendarPlus size={18} weight="bold" />
    </button>
  );
};
